<template>
    <h3 class="page-heading">
            &nbsp;&nbsp; <v-icon>mdi-magnify</v-icon>&nbsp;Find samples by measure code, name or description
          </h3>
    <v-container style="padding-left: 0; padding-right: 0;">
      
      <v-row id="search-options" class="search-options">
        <!-- SEARCH TEXT -->
        <v-col cols="6">
          <v-text-field
            id="search_text_input"
            variant="outlined"
            density="compact"
            placeholder="Enter text (hit enter to add search tag)"
            v-model="search_text"
            @keyup.enter="addSearchTextTag"
          ></v-text-field>
        </v-col>
  
        <v-col cols="1"></v-col>
        
        <v-col>
          <div class="d-inline-block" style="font-size: 1.5rem;">
            <v-chip
              v-for="tag in search_text_tags"
              :key="tag"
              class="ma-1"
              @click="removeSearchTextTag(tag)"
              close
              outlined
            >
              {{ tag }}
              <v-icon right>mdi-close-circle</v-icon>
            </v-chip>
          </div>
        </v-col>
      </v-row>
  
      <v-row>
        <v-col class="text-left">
          <v-btn small outlined color="dark" @click="resetTable">
            <v-icon left>mdi-rotate-left</v-icon> Reset Table
          </v-btn>
          &nbsp;
          <v-btn small outlined color="dark" @click="addToBasket(null, 'table', included_measures); showModal('addedItemModal')">
            <v-icon left>mdi-cart-plus</v-icon> Add Table to Basket
          </v-btn>
          &nbsp;
          <v-btn small outlined color="dark" @click="addRowsToBasket();">
            <v-icon left>mdi-cart-plus</v-icon> Add Selected Measures to Basket
          </v-btn>
        </v-col>
      </v-row>
  
      <v-card>
        <v-table class="lcid-info-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="field in measure_headings"
                  :key="field.key"
                  :style="{ width: field.key === 'description' ? '48%' : (field.key === 'long_name' ? '18%' : (field.key === 'data_category' ? '20%' : (field.key === 'select' ? '6%' : (field.key === 'cohort' ? '11%' : (field.key === 'all_sessions' ? '22%' : '15%'))))) }"
                >
                  <span v-if="field.key === 'select'">
                    <v-checkbox v-model="select_all"  @update:modelValue="toggleCurrentMeasures()" class="my-0" density="compact" hide-details></v-checkbox>
                  </span>
                  <span v-else-if="field.key === 'cohort'">
                    <strong>{{ field.label }}</strong>
                  </span>
                  <span v-else-if="field.key === 'session'">
                    <strong>{{ field.label }}</strong>
                  </span>
                  <span v-else>
                    <strong>{{ field.label }}</strong>
                  </span>
                  
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in included_measures" >
                <td v-for="field in measure_headings" >
                  <span v-if="field.key === 'all_sessions'">
                    <span v-for="(opt, idx)  in all_arrays['session']" class="my-0" style="font-family: monospace;">
                      <span v-if="item[field.key].includes(opt.substring(1))">
                        {{opt.substring(1)}}
                      </span>
                      <span v-else style="color:#c8d1e0">
                        {{ ((idx+1) % 2) == 0 ? 'Xa' : 'X' }}
                      </span>&nbsp;
                    </span>
                  </span>
                  <span v-else-if="field.key === 'cohort'" style="line-height: 1.5em;">
                    <span v-for="el of item[field.key]">
                      <span class="element-pill">{{el}}</span>&nbsp;
                    </span>
                  </span>
                  <span v-else-if="field.key === 'data_category'" style="line-height: 1.5em;">
                    <span v-for="el of item[field.key]" class="element-pill">{{el}} <br></span>
                  </span>
                  <span v-else-if="field.key === 'select'">
                    <v-checkbox v-model="selected_measures_boxes" :value="item['short_name']" @update:modelValue="" class="my-0" density="compact" hide-details></v-checkbox>
                  </span>
                  <span v-else>
                    {{ item[field.key] }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-table>
      </v-card>
    </v-container>

    <v-dialog v-model="showAddedItemModal" max-width="500px">
        <v-card>
        <v-card-title>Added to basket!</v-card-title>
        <v-card-text class="text-center">
            <h3>You now have {{ basket.length }} {{ basket.length > 1 ? 'items' : 'item' }} in your basket</h3>
        </v-card-text>
        <v-card-actions>
            <v-btn text="Continue Browsing" @click="hideModal('addedItemModal')"></v-btn>
            <v-btn text="View Basket" @click="viewBasket"></v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="noMeasuresSelectedModal" max-width="500px">
        <v-card>
        <v-card-title>No measures selected</v-card-title>
        <v-card-text class="text-left">
            Please select measures before adding them to your basket.
        </v-card-text>
        <v-card-actions>
            <v-btn text="Ok" @click="noMeasuresSelectedModal = false"></v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>


</template>

<script setup>
    import { ref, inject, computed, watch, toRaw} from 'vue'

    const addToBasket = inject('addToBasket')
    const basket = inject('basket')
    const showAddedItemModal = ref(false);
    const noMeasuresSelectedModal = ref(false)
    const select_all = ref(false)
    const selected_measures_boxes = ref([])
    const all_arrays = inject('all_arrays')
    const measure_headings = [
      {
        key: "select",
        label: "Select"
      },
      {
          key: "short_name",
          label: "Code",
      },
      {
          key: "long_name",
          label: "Name",
      },
      {
          key: "description",
          label: "Description",
      },
      {
          key: "data_type",
          label: "Type",
      },
      {
          key: "data_category",
          label: "Category",
      },
      {
          key: "cohort",
          label: "Cohort"
      },
      {
          key: "all_sessions",
          label: "Session"
      }
    ]
    var search_text = ref("");
    var search_text_tags = ref([]);

    const measure_data = inject('measure_data')
    const selected_component = inject('selected_component')

    const included_measures = computed(() => {
        return measure_data.value.filter((c) => {
            if (search_text_tags.value.length == 0) {
                // console.log("true")
                return true;
            }
            return search_text_tags.value.some((v) =>
                c["short_name"]?.toLowerCase().indexOf(v.toLowerCase()) >= 0 ||
                c["long_name"]?.toLowerCase().indexOf(v.toLowerCase()) >= 0 ||
                c["description"]?.toLowerCase().indexOf(v.toLowerCase()) >= 0 ||
                c["data_type"]?.toLowerCase().indexOf(v.toLowerCase()) >= 0
            );
        });
    });

    const selected_measures = computed(() => {
      return measure_data.value.filter((m) => {
        return selected_measures_boxes.value.includes(m.short_name)
      })        
    });

    // Synchronize selected_measures_boxes when included_measures changes
    watch(included_measures, (newIncluded) => {
      const currentShortNames = newIncluded.map(m => m.short_name);
      selected_measures_boxes.value = selected_measures_boxes.value.filter(s => currentShortNames.includes(s));
    });


    function toggleCurrentMeasures() {

      console.log(select_all.value)
      if (select_all.value) {
         var allSnames = included_measures.value.map((m) => {
          return m["short_name"]
        })
        console.log(allSnames)
        selected_measures_boxes.value = allSnames
      } else {
        selected_measures_boxes.value = []
      }
    }

    function resetTable() {
        search_text.value = ""
        search_text_tags.value = []
        select_all.value = false
        selected_measures_boxes.value = []
    }

    function addSearchTextTag(option) {
        if (search_text_tags.value.indexOf(search_text.value) < 0) {
            search_text_tags.value.push(search_text.value);
        }
        search_text.value = "";
    }

    function removeSearchTextTag(tag) {
        var idx = search_text_tags.value.indexOf(tag);
        if (idx > -1) {
            search_text_tags.value.splice(idx, 1);
        }
    }
    function viewBasket() {
        showAddedItemModal.value = false;
        selected_component.value = 'basket'
    }

    const showModal = (modalRef) => {
      showAddedItemModal.value = true;
    };

    const hideModal = (modalRef) => {
      showAddedItemModal.value = false;
    };

    function addRowsToBasket() {
      if (selected_measures.value.length == 0) {
        noMeasuresSelectedModal.value = true
      } else {
        addToBasket(null, 'table', selected_measures.value)
        showAddedItemModal.value = true
      }
    }
</script>

<style scoped>

  .element-pill {
    padding: 0.1em 0.3em;
    border-radius: 1em;
    border: 1px solid black ;
    margin-bottom:0.5em;
  }

</style>





